import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Hidden from '@material-ui/core/Hidden';

import debounce from '../../utils/Debounce';
import HorizontalScroll from '../../utils/HorizontalScroll';
import Frise from '../../components/Frise';

import styles from './styles';

class MainContainer extends React.Component {
  constructor(props) {
    super(props);
    this.scrollDirection = null;
    this.onScroll = this.onScroll.bind(this);
    this.onResize = debounce(this.onResize.bind(this), 300).bind(this);
    this.onScrollInterval = this.onScrollInterval.bind(this);
    this.scrollInterval = setInterval(this.onScrollInterval, 10);
    this.speed = 20;
    this.maxScroll = 100;

    this.state = {
      scroll: 0,
      index: this.refreshIndex(),
    };
  }

  componentDidMount() {
    window.addEventListener('mouseup', () => this.onMouseLeave());
    window.addEventListener('resize', () => this.onResize(true));
    this.onResize(false);
  }

  refreshIndex() {
    this.winWidth = window.innerWidth < 1400 ? 1400 : window.innerWidth;
    const { index } = this.props.data;
    let totalWidth = 0;
    let width;
    let x;
    let subWidth;
    let totalSubWidth;
    let subItem;
    let subBlocks = [];
    return index.map(item => {
      if (item.unit === '%') {
        width = parseInt((item.width / 100) * this.winWidth, 10);
      } else {
        width = parseInt(item.width, 10);
      }
      subWidth = 0;
      totalSubWidth = 0;
      subBlocks = [];
      if (item.subBlocks) {
        item.subBlocks.forEach(sub => {
          subItem = { ...sub };
          if (item.unit === '%') {
            subWidth = parseInt((sub.width / 100) * this.winWidth, 10);
          } else {
            subWidth = parseInt(sub.width, 10);
          }
          subItem.width = subWidth;
          subItem.unit = 'px';
          subItem.x = totalWidth + width + totalSubWidth;
          // subItem
          totalSubWidth += subWidth;
          subBlocks.push(subItem);
        });
      }
      x = totalWidth;
      totalWidth += width + totalSubWidth;
      return {
        ...item,
        subBlocks,
        x,
        width,
        unit: 'px',
      };
    });
  }

  onScroll(value) {
    if (value > 0) {
      this.setState({ scroll: 0 });
    } else if (value < -this.maxScroll) {
      this.setState({ scroll: -this.maxScroll });
    } else {
      this.setState({ scroll: value });
    }
  }

  onMouseDown(direction) {
    this.scrollDirection = direction;
  }

  onMouseLeave() {
    this.scrollDirection = null;
  }

  onResize(refreshIndex) {
    const container = document.querySelector('.scroll-horizontal > div');
    if (container) {
      this.maxScroll = container.clientWidth - window.innerWidth;
    }
    if (refreshIndex) {
      this.setState({
        index: this.refreshIndex(),
      });
    }
  }

  onScrollInterval() {
    if (this.scrollDirection !== null) {
      this.setState(prev => {
        const scroll = prev.scroll + this.scrollDirection * this.speed;
        if (this.scrollDirection > 0 && scroll > 0) {
          return null;
        }
        if (this.scrollDirection < 0 && scroll < -this.maxScroll) {
          return null;
        }
        return { scroll };
      });
    }
  }

  onSlideRight() {
    const { index, scroll: negScroll } = this.state;
    const scroll = -negScroll;
    let item;
    let sub;
    let value = -1;
    for (let i = index.length - 1; i >= 0; i--) {
      item = index[i];
      if (item.subBlocks) {
        for (let j = item.subBlocks.length - 1; j >= 0; j--) {
          sub = item.subBlocks[j];
          if (scroll > sub.x + 10) {
            value = sub.x;
            break;
          }
        }
      }
      if (value > -1) {
        break;
      } else if (scroll > item.x + 10) {
        value = item.x;
        break;
      }
    }
    if (value > -1) {
      this.onScroll(-value);
    }
  }

  onSlideLeft() {
    const { index, scroll: negScroll } = this.state;
    const scroll = -negScroll;
    let item;
    let sub;
    let value = -1;
    for (let i = 0; i < index.length; i++) {
      item = index[i];
      if (scroll >= item.x - 10) {
        if (item.subBlocks) {
          for (let j = 0; j < item.subBlocks.length; j++) {
            sub = item.subBlocks[j];
            if (scroll < sub.x - 10) {
              value = sub.x;
              break;
            }
          }
        }
      } else if (value > -1) {
        break;
      } else {
        value = item.x;
        break;
      }
    }
    if (value > -1) {
      this.onScroll(-value);
    }
  }

  renderDesktop() {
    const { classes, children, data, onPopup } = this.props;
    const { index } = this.state;
    return (
      <div className={classes.containerDesktop}>
        <HorizontalScroll reverseScroll onChange={this.onScroll} value={this.state.scroll}>
          {children}
        </HorizontalScroll>
        <Frise
          data={data}
          onClick={v => this.onScroll(-v)}
          onPopup={onPopup}
          scroll={this.state.scroll}
          index={index}
        />
        <IconButton
          className={`${classes.arrow} ${classes.arrowBack}`}
          size="medium"
          // onMouseDown={() => this.onMouseDown(1)}
          onClick={() => this.onSlideRight()}
        >
          <ArrowBackIosIcon fontSize="large" />
        </IconButton>
        <IconButton
          className={`${classes.arrow} ${classes.arrowNext}`}
          size="medium"
          // onMouseDown={() => this.onMouseDown(-1)}
          onClick={() => this.onSlideLeft()}
        >
          <ArrowForwardIosIcon fontSize="large" />
        </IconButton>
      </div>
    );
  }

  renderMobile() {
    const { classes, children } = this.props;
    return <div className={classes.containerMobile}>{children}</div>;
  }

  render() {
    return (
      <>
        <Hidden mdDown>{this.renderDesktop()}</Hidden>
        <Hidden lgUp>{this.renderMobile()}</Hidden>
      </>
    );
  }
}

MainContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  data: PropTypes.object,
  onPopup: PropTypes.func,
};

export default withStyles(styles)(MainContainer);
